'use client'
import { useEffect } from 'react'
import Layout from '../Layout/Layout'

export const SeoContent = ({ content }) => {
  useEffect(() => {
    // content seo expander
    const triggerExpander = document.querySelector('.js-expander-trigger')
    const expanderWrapper = triggerExpander?.closest('.Expander')
    const addClass = () => expanderWrapper?.classList.toggle('isOpened')
    triggerExpander?.addEventListener('click', addClass);

    return () => {
      triggerExpander?.removeEventListener('click', addClass);
    }
  }, [])

  return (
    <Layout container='padding'>
      <div className={'move-container'} dangerouslySetInnerHTML={{ __html: content }} />
    </Layout>
  )
}

export default SeoContent
